import paiqian from "@/components/event/paiqian";
import renyuanpaiqian from "@/components/event/paiqian";
import enentWait from "@/components/event/enentWait";
import eventAllList from "@/components/event/eventAllList";
import eventEnd from "@/components/event/eventEnd";
import eventAlready from "@/components/event/eventAlready";
import eventDelayApply from "@/components/event/eventDelayApply";
import eventDelayApproval from "@/components/event/eventDelayApproval";
import eventRecheck from "@/components/event/eventRecheck";
import eventWork from "@/components/event/work";
import trackTask from "@/components/event/trackTask";
import trackSync from "@/components/event/trackSync";
import eventWord from "@/components/event/word";
var data = [
  {
    path: "/paiqian",
    component: paiqian,
  },
  {
    path: "/renyuanpaiqian",
    component: renyuanpaiqian,
  },
  {
    path: "/enentWait",
    component: enentWait,
  },
  {
    path: "/eventAllList",
    component: eventAllList,
  },
  {
    path: "/eventEnd",
    component: eventEnd,
  },
  {
    path: "/eventAlready",
    component: eventAlready,
  },
  {
    path: "/eventDelayApply",
    component: eventDelayApply,
  },
  {
    path: "/eventDelayApproval",
    component: eventDelayApproval,
  },
  {
    path: "/eventRecheck",
    component: eventRecheck,
  },
  {
    path: "/work",
    component: eventWork,
  },
  {
    path: "/jielongSys",
    component: eventWord,
  },
  {
    path: "/trackTask",
    component: trackTask,
  },
  {
    path: "/trackSync",
    component: trackSync,
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/event.js